export default function renderAdrTaLaborV3(data) {
  return function (pdf) {
    let cursorY = this.cursorY;

    cursorY += 2;
    pdf.line(15, cursorY, 590, cursorY);
    pdf.setFont("helvetica", "bold").setFontSize(12);
    cursorY += 15;
    pdf.text("LABOR", 302, cursorY, {
      align: "center",
    });
    cursorY += 4;
    pdf.line(15, cursorY, 590, cursorY);
  };
}
